/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type AlertSeverity = "ERROR" | "INFO" | "SUCCESS" | "WARNING";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ElectRoleFiller_change$ref: FragmentReference;
declare export opaque type ElectRoleFiller_change$fragmentType: ElectRoleFiller_change$ref;
export type ElectRoleFiller_change = {|
  +id: string,
  +databaseId: string,
  +command: string,
  +type: string,
  +alerts: $ReadOnlyArray<{|
    +path: ?string,
    +message: string,
    +severity: AlertSeverity,
  |}>,
  +organization?: {|
    +autocompletePeople: $ReadOnlyArray<{|
      +name: string,
      +databaseId: string,
    |}>
  |},
  +assignedUntil?: ?any,
  +person?: ?{|
    +databaseId: string,
    +name: string,
  |},
  +role?: ?{|
    +databaseId: string,
    +localizedName: string,
  |},
  +$refType: ElectRoleFiller_change$ref,
|};
export type ElectRoleFiller_change$data = ElectRoleFiller_change;
export type ElectRoleFiller_change$key = {
  +$data?: ElectRoleFiller_change$data,
  +$fragmentRefs: ElectRoleFiller_change$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ElectRoleFiller_change",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "command",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Alert",
      "kind": "LinkedField",
      "name": "alerts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "severity",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 10000
                }
              ],
              "concreteType": "AutocompletePerson",
              "kind": "LinkedField",
              "name": "autocompletePeople",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/)
              ],
              "storageKey": "autocompletePeople(first:10000)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignedUntil",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "localizedName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ElectRoleFillerChange",
      "abstractKey": null
    }
  ],
  "type": "DescribeChangeable",
  "abstractKey": "__isDescribeChangeable"
};
})();
// prettier-ignore
(node/*: any*/).hash = '0c0fc3170090587c23aba941e42bf967';

module.exports = node;
